import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

type ProductCategory = {
  id: number
  name: string
  image: string
  created_at: string
  active: boolean
}

const getProductCategories = async () => {
  const { data, error } = await supabase
    .from('products_categories')
    .select('*')
    .eq('active', true)

  if (error) {
    throw new Error(error.message)
  }

  return data as ProductCategory[]
}

export default function useGetProductCategories() {
  return useQuery({
    queryKey: ['useGetProductCategories'],
    queryFn: () => getProductCategories(),
    staleTime: 0,
  })
}
